module.exports = __webpack_public_path__ + "static/slider-2-ae0eab6e4a9210405299824990e55555.png";